// Module
var code = "<div class=\"hbox hbox-auto-xs hbox-auto-sm bg-light\">\n\n    <div class=\"col w-xl lter b-r\" ui-view=\"discountList\"></div>\n    \n    <div class=\"col w-xxl bg-white-only\" ui-view=\"discountView\"></div>\n    \n    <div class=\"col\"></div>\n\n</div>";
// Exports
module.exports = code;